import { render } from "./Error.vue?vue&type=template&id=284bac54&scoped=true"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"

import "./Error.vue?vue&type=style&index=0&id=284bac54&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284bac54"]])

export default __exports__